import DOMPurify from "dompurify";

/**
 * Strip all HTML tags (and decode entities) from a rich-text string, returning
 * plain text. Use for compact, non-rich contexts where markup must not render
 * or would break layout: nav labels, tooltips (`title=`), dropdown options,
 * clamped teasers, and chart labels rendered inside SVG.
 *
 * For full rich-text display use `DOMPurify.sanitize(html)` with
 * `dangerouslySetInnerHTML` instead.
 */
export function htmlToText(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
